"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeaderClose = exports.ModalHeaderTitle = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = __importDefault(require("../Util/Icon"));
const Button_1 = __importDefault(require("../Util/Button"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const ModalContext_1 = require("../../contexts/ModalContext");
const helpers_1 = require("../../lib/helpers");
const Journey_1 = require("../../lib/Journey");
const mergeProps_1 = __importDefault(require("../../lib/mergeProps"));
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
exports.ModalHeaderTitle = createJourneyComponent_1.createJourneyComponent('j-modal-header-title', 'div');
exports.ModalHeaderClose = createJourneyComponent_1.createJourneyComponent('j-modal-header-close', (props) => {
    const { onClose } = react_1.useContext(ModalContext_1.ModalContext);
    return react_1.default.createElement(Button_1.default, Object.assign({}, mergeProps_1.default(props, { onClick: onClose })));
});
const ModalHeader = (props) => {
    const { children } = props;
    const { onClose } = react_1.useContext(ModalContext_1.ModalContext);
    const hasModalHeaderTitle = helpers_1.hasChildComponent(props, 'j-modal-header-title');
    const hasModalHeaderClose = helpers_1.hasChildComponent(props, 'j-modal-header-close');
    if (!hasModalHeaderClose && hasModalHeaderTitle) {
        console.error('If you breakout the <ModalHeader/> with a <ModalHeaderClose/> you now must also break out the <ModalHeaderTitle/>.');
    }
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)),
        react_1.default.createElement(exports.ModalHeaderTitle, { disableMount: hasModalHeaderTitle }, children),
        (hasModalHeaderClose || hasModalHeaderTitle) && children,
        react_1.default.createElement(exports.ModalHeaderClose, { onClick: onClose, disableMount: hasModalHeaderClose },
            react_1.default.createElement(Icon_1.default, { src: Journey_1.Journey.icons().CLOSE }))));
};
exports.default = withJourney_1.default('j-modal-header', ModalHeader);
